import { storage, StorageKey } from '@/lib/storage';
import type { AppDispatch } from '@/store';
import { setActiveGames, setSelectedGames } from '@/store/core.slice';

/**
 * Sceglie il gioco attivo (`selectedGames === activeGames === [id]`) e lo ricorda per il prossimo avvio.
 * UNA definizione, per chi la sceglie dal selettore (`useGameSelection.selectGame`) e per chi porta in un gioco da
 * fuori — «Vai» della barra della coda, per un biglietto di un gioco che non e' quello attivo.
 */
export function selezionaGioco(dispatch: AppDispatch, id: number): void {
  dispatch(setSelectedGames([id]));
  dispatch(setActiveGames([id]));
  storage.set(StorageKey.SelectedGameId, String(id));
}
